import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import ViewButton from '../../components/common/ViewButton'
import { useFilters } from '../../hooks/useFilters'
import { FILTER_TYPES } from '../../constants/filters'
import DisplayActiveSuspended from '../../components/admin/DisplayActiveSuspended'

export default function CustomerManagement() {
  const { filters, renderFilters, renderPagination } = useFilters()

  const { data: customersData } = useQuery({
    queryKey: QueryKeys.adminListCustomers(filters),
    queryFn: () => handleGetRequest('/admin/customers', filters),
  })

  const customers = customersData?.data || []

  return (
    <>
      <div className="flex gap-6 mb-8">
        {renderFilters([FILTER_TYPES.search, FILTER_TYPES.isActive, FILTER_TYPES.sort])}
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-left text-gray-700">
          <thead className="bg-secondary-100 [&>th]:px-6 [&>th]:py-4 [&>th]:font-medium [&>th]:text-black [&>th]:text-base">
            <tr>
              <th className="px-6 py-3">Customer Name</th>
              <th className="px-6 py-3">Phone Number</th>
              <th className="px-6 py-3">Status</th>
              <th className="px-6 py-3">Actions</th>
            </tr>
          </thead>
          <tbody className="text-base font-fontFamily">
            {customers.map((customer, index) => (
              <tr
                key={customer.id}
                className={`border-b ${index % 2 === 0 ? 'bg-background' : 'bg-background-muted'}`}
              >
                <td className="px-6 py-4">{customer.name}</td>
                <td className="px-6 py-4">{customer.phoneNumber}</td>
                <td>
                  <DisplayActiveSuspended
                    isActive={customer.isActive}
                    suspendedBy={customer.suspendedBy}
                  />
                </td>
                <td className="px-6 py-4">
                  <div className="flex gap-2">
                    <ViewButton redirectPath={`/admin/customers/${customer.id}`} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {renderPagination(customersData?.meta)}
    </>
  )
}
